module.exports = __webpack_public_path__ + "img/16_peace_and_justice_strong_institutions_color.63c63622.svg";